/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import { TrashSecondaryIcon } from "../../Common/Svgs/TrashIcon";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import Button from "../../Core/Components/CustomButton";
import { CONTAINER_STATUS } from "./data";
import ContainerIcon from "../../Common/Svgs/ContainerIcon";
import { updateContainer } from "../../Redux/Slices/container.slice";
import { client } from "../../Utils/axiosClient";
import { getContainers } from "../../Redux/APIs/containersAPI";

const LOCAL_DEFAULT_LIMIT = 10;

const DeleteContainerModal = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { deleteContainerModal } = useSelector((state) => state.containers);

  const onConfirm = async () => {
    const payload = {
      containerId: deleteContainerModal?.data?.id,
    };

    try {
      dispatch(updateContainer({ key: "loading", value: true }));

      await client.post(
        `${process.env.REACT_APP_API_URL}/containers/delete-container`,
        payload,
      );

      const response = await dispatch(
        getContainers({
          offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );

      // If no records exist for the current page, move to the previous page
      if (!response.payload.result.length && currentPage > 1) {
        const previousPage = currentPage - 1;
        setCurrentPage(previousPage);

        await dispatch(
          getContainers({
            offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
          }),
        );
      }

      dispatch(
        updateContainer({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "1 container deleted",
              description: `Container ${deleteContainerModal?.data?.containerName} was deleted successfully`,
            },
          },
        }),
      );
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateContainer({ key: "loading", value: false }));
      onCancel();
    }
  };

  const getBody = () => {
    if (+deleteContainerModal?.data?.status === CONTAINER_STATUS.ON_A_TRIP) {
      return (
        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Cannot delete container
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            This container cannot be deleted now as it is currently on a trip,
            please try again when it is in a hub station
          </p>
        </div>
      );
    }

    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-alert-red font-poppins">
          Delete container
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to delete this container from the system?
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          This action cannot be undone.
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="relative">
            <div className="absolute top-0 right-0">
              <TrashSecondaryIcon className="text-alert-red" />
            </div>
            <CustomRoundedImage
              size="w-12 h-12"
              image={<ContainerIcon size={24} className="text-white" />}
              background="bg-primary"
            />
          </div>
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          {deleteContainerModal?.data?.status ===
          CONTAINER_STATUS.HUB_STATION ? (
            <Button colors="alert" size="primary" onClick={onConfirm}>
              Confirm
            </Button>
          ) : null}
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteContainerModal;
